const Datepicker = require('vuejs-datepicker');
const DateUtils = require('vuejs-datepicker/src/utils/DateUtils').default;

module.exports = {
  extends: Datepicker,
  componentName: 'datepicker',

  props: {
    value: {
      validator: function (val) {
        return val === null || Array.isArray(val);
      }
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      selectedDate: []
    };
  },

  computed: {
    hasDatesSelected () {
      return this.selectedDate !== [];
    },

    formattedValue () {
      if (!this.hasDatesSelected) {
        return null;
      }

      if(typeof this.format === 'function') {
        return this.function(this.selectedDate);
      }

      const formatted = this.selectedDate.map((date) => {
        return DateUtils.formatDate(
          new Date(date), this.format, this.translation
          );
      });

      return formatted.join(', ');
    }
  },

  methods: {
    resetDefaultDate () {
      if (!this.hasDatesSelected) {
        return this.setPageDate();
      }

      this.setPageDate(this.selectedDate[0]);
    },

    removeSelectedDate (date) {
      this.removeSelectedDateByIndex(
        this.getSelectedDateIndex(date)
      );
    },

    removeSelectedDateByIndex(index) {
      if(index === -1) {
        return;
      }

      this.selectedDate.splice(index, 1);
    },

    setDate (timestamp) {
      const date = new Date(timestamp);

      if(this.isSelectedDate(date)) {
        this.removeSelectedDate(date);
      } else {
        this.addSelectedDate(new Date(date));
      }

      this.setPageDate(date);

      this.$emit('selected', new Date(date));
      this.$emit('input', this.selectedDate);
    },

    clearDate () {
      this.selectedDate = [];
      this.$emit('selected', null);
      this.$emit('input', null);
      this.$emit('cleared');
    },

    getSelectedDateIndex (date) {
      if(!date || Array.isArray(date)) {
        return;
      }

      const index = this.selectedDate.findIndex((item) => {
        return item.toDateString() === date.toDateString();
      });

      return index;
    },

    isSelectedDate (date) {
      return this.getSelectedDateIndex(date) !== -1;
    },

    isSelectedMonth (date) {
      const hasDate = this.selectedDate.findIndex((item) => {
        return item.getFullYear() === date.getFullYear() &&
          item.getMonth() === date.getMonth();
      });

      return hasDate !== -1;
    },

    isSelectedYear (date) {
      const hasDate = this.selectedDate.findIndex((item) => {
        return item.getFullYear() === date.getFullYear();
      });

      return hasDate !== -1;
    },

    setValue (date) {
      if (typeof date === 'string') {
        let parsed = new Date(date)
        date = isNaN(parsed.valueOf()) ? null : parsed
      }

      if(Array.isArray(date)) {
        return;
      }

      if (!date) {
        return this.setPageDate();
      }

      if(!this.isSelectedDate(date)) {
        this.addSelectedDate(date);
      } else {
        this.removeSelectedDate(date);
      }

      this.setPageDate(date);
    },

    addSelectedDate(date) {
      if(this.multiple) {
        return this.selectedDate.push(date);
      }

      return this.selectedDate = [date];
    }
  }
};
